import "./ProjectItem.css";

const ProjectItem = (props) => {
  return (
    <div className="project-item-container">
      <div className="project-item-details">
        <p className="project-name">{props.name}</p>
        <p className="project-content">{props.content}</p>
        <p className="project-stack">{props.stack}</p>
        <p>
          <a
            className="project-link"
            href={props.github_link}
            target="_blank"
            rel="noreferrer"
          >
            Source Code
          </a>
        </p>
      </div>
      <div className="project-item-image-container">
        <a href={props.link} target="_blank" rel="noreferrer">
          <img className="project-item-image" src={props.image} alt="404"></img>
        </a>
      </div>
    </div>
  );
};

export default ProjectItem;
